export default class UrlParams
{
    constructor(url) {
        // parse query string and store parameters in an array
        var urlParams = {};
        var match;
        var pl     = /\+/g;  // Regex for replacing addition symbol with a space
        var search = /([^&=]+)=?([^&]*)/g;
        var decode = function (s) {
            return decodeURIComponent(s.replace(pl, " "));
        };

        var qIndex = url.indexOf('?');

        this.baseUrl = qIndex == -1 ? url : url.substr(0, qIndex);
        var query  = qIndex == -1 ? '' : url.substr(qIndex).substr(1);
        while (match = search.exec(query)) {
           urlParams[decode(match[1])] = decode(match[2]);
        }

        this.urlParams = urlParams;
    }

    getParams() {
        return this.urlParams;
    }

    getBaseUrl() {
        return this.baseUrl;
    }
}



// WEBPACK FOOTER //
// ./app/UrlParams.js